<template>
    <div class="optionsWrapper">
    <transition mode="out-in" name="slide-partial">
        <div class="option year1893" @click="redirect('1893', 8)">
            <p>
                <inline-svg :src="require(`../../assets/imgs/main/1893_${chosenLanguage}.svg`)" />
                <inline-svg :src="require('../../assets/imgs/gui/button_up.svg')" class="arrowButton"/>
            </p>
        </div>
    </transition>

        <div class="option year1925" @click="redirect('1925', 6)">
            <p>
                <inline-svg :src="require(`../../assets/imgs/main/1925_${chosenLanguage}.svg`)"/>
                <inline-svg :src="require('../../assets/imgs/gui/button_up.svg')" class="arrowButton"/>
            </p>
        </div> 

        <div class="option year1949" @click="redirect('1949', 4)">
            <p>
                <inline-svg :src="require(`../../assets/imgs/main/1949_${chosenLanguage}.svg`)"/>
                <inline-svg :src="require('../../assets/imgs/gui/button_up.svg')" class="arrowButton"/>
            </p>
        </div>  

        <div class="option year1951" @click="redirect('1951', 3)">
            <p>
                <inline-svg :src="require(`../../assets/imgs/main/1951_${chosenLanguage}.svg`)"/>
                <inline-svg :src="require('../../assets/imgs/gui/button_up.svg')" class="arrowButton"/>
            </p>
        </div>   

        <div class="option year1956" @click="redirect('1956', 3)">
            <p class="year1956">
                <inline-svg :src="require(`../../assets/imgs/main/1956_${chosenLanguage}.svg`)"/>
                <inline-svg :src="require('../../assets/imgs/gui/button_up.svg')" class="arrowButton"/>
            </p>
        </div>  

        <div class="option year1960" @click="redirect('1960', 4)">
            <p>
                <inline-svg :src="require(`../../assets/imgs/main/1960_${chosenLanguage}.svg`)"/>
                <inline-svg :src="require('../../assets/imgs/gui/button_up.svg')" class="arrowButton"/>
            </p>
        </div>    

        <div class="option year1982" @click="redirect('1982', 3)">
            <p>
                <inline-svg :src="require(`../../assets/imgs/main/1982_${chosenLanguage}.svg`)"/>
                <inline-svg :src="require('../../assets/imgs/gui/button_up.svg')" class="arrowButton"/>
            </p>
        </div>  

        <div class="option year1993" @click="redirect('1993', 9)">
            <p>
                <inline-svg :src="require(`../../assets/imgs/main/1993_${chosenLanguage}.svg`)"/>
                <inline-svg :src="require('../../assets/imgs/gui/button_up.svg')" class="arrowButton"/>
            </p>
        </div> 

        <div class="option year2016" @click="redirect('2016', 5)">
            <p>
                <inline-svg :src="require(`../../assets/imgs/main/2016_${chosenLanguage}.svg`)"/>
                <inline-svg :src="require('../../assets/imgs/gui/button_up.svg')" class="arrowButton"/>
            </p>
        </div>   
    </div>
</template>
<script>
export default {
  name: 'MenuOptions',
  data() {
      return {
        diffBackgroundCol: ['1925', '1951', '1960', '1993'],
      }
  },
  methods: {
      redirect: function (year, rows) {
          const target = document.getElementsByClassName('year'+year)[0];
          if (target.classList.length === 2) {
            target.classList.add('clicked');
            setTimeout(() => {
                this.reroute(year, rows);
            }, 500);
            setTimeout(() => {
                target.classList.remove('clicked');
            }, 1000);
          }
        },
        reroute(year, rows) {
            this.$router.push({name: 'timespan', params: {year: year, rows: rows }}).catch((err) => {
                if (err.name !== 'NavigationDuplicated' &&
                        !err.message.includes('Avoided redundant navigation to current location')) {
                console.info(err);
                }        
            });
        }
  }
}
</script>

<style lang="scss">

.optionsWrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    overflow: hidden;

   .option{
        background-color: var(--timespan-background-color-dark);
        height: 118px;
        position: relative;
        right: -461px;
        width: 965px;

        p svg {
            padding: 5px 0 0 28px
        }

        &.clicked {
            transition: 0.3s;
            right: 0;
        }

        .arrowButton {
            transform: rotate(90deg);
            float: right;
            position: relative;
            top: 11px;
            right: 19px;
        }
    }
}

</style>